import type { Company } from '@xing-com/crate-common-graphql-types';

import type { TopCompany } from '../types';

const formatKununuRecommendationRate = (rate: number): number =>
  Math.round(rate * 100);

export const createTopCompany = (item: Company): TopCompany => ({
  id: item.id,
  hasOpenJobs: true,
  jobsCount: item.jobsCount && item.jobsCount > 0 ? item.jobsCount : undefined,
  name: item.companyName ?? '',
  size: item.companySize ?? undefined,
  companyUrl: item.links?.public ?? undefined,
  jobsUrl: item.links?.public ? `${item.links.public}/jobs` : undefined,
  industry: item.industry?.localizationValue,
  kununuRatting: item.kununuData?.ratingAverage ?? undefined,
  kununuRecomendationRate: item.kununuData?.recommendationRate
    ? formatKununuRecommendationRate(item.kununuData?.recommendationRate)
    : undefined,
  location: item.address?.city ?? undefined,
  profileImageUri: item.logos?.logo128px ?? undefined,
});

export const createTopCompanies = (items: Company[]): TopCompany[] =>
  items.map(createTopCompany);
